// 添加样式依赖
import '@/common/css/index.scss';
import './help.scss';
// 添加js依赖
import $ from 'jquery';

$(function() {
  $('.menu-item .menu-title').click(function() {
    const flag = $(this).attr('data-flag');
    if (flag === '0') {
      $(this).addClass('active');
      $(this).attr('data-flag', '1');
    } else {
      $(this).removeClass('active');
      $(this).attr('data-flag', '0');
    }
    $(this)
      .siblings('.sub-menu')
      .slideToggle();
  });

  $('.sub-menu-item').click(function() {
    const id = $(this).attr('data-id');
    $('.sub-menu-item').removeClass('active');
    $(this).addClass('active');
    $('.J_content[data-id]').hide();
    $(`.J_content[data-id=${id}]`).show();
  });
});
